export enum RELAPSE {
  ONE = '1',
  TWO = '2',
  THREE = '3',
  MORE = '4+',
}

export const relapseMapping = {
  [RELAPSE.ONE]: $localize`:@@common_relapse_one:1`,
  [RELAPSE.TWO]: $localize`:@@common_relapse_two:2`,
  [RELAPSE.THREE]: $localize`:@@common_relapse_three:3`,
  [RELAPSE.MORE]: $localize`:@@common_relapse_more:4+`,
};
